import { render, staticRenderFns } from "./BoletinesEnviados.vue?vue&type=template&id=f52e23b2"
import script from "./BoletinesEnviados.vue?vue&type=script&lang=js"
export * from "./BoletinesEnviados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports